import { Row } from '@estee/elc-grid';
import { configConsumer } from '@estee/elc-service';
import { observer } from 'mobx-react';
import * as React from 'react';
import styled from 'styled-components';
import { StickyWrapper } from '../sticky-wrapper/StickyWrapper';

export enum GridActionsBarTypes {
    STICKY = 'sticky',
    INLINE = 'inline'
}

export interface IGridActionsBarConfig {
    type: GridActionsBarTypes;
    stickyElementsSelectors: string[];
}

export interface IGridActionsBarWrapper {
    children: JSX.Element;
    className?: string;
    config?: {
        gridActionsBar: IGridActionsBarConfig;
    };
}

const StyledRow = styled(Row)`
    display: flex;
    justify-content: space-between;
    user-select: none;
`;

export const GridActionsBarWrapper = configConsumer(['gridActionsBar'])(
    observer(function GridActionsBarWrapper(props: IGridActionsBarWrapper) {
        if (props.config?.gridActionsBar?.type === GridActionsBarTypes.STICKY) {
            return (
                <StickyWrapper
                    className={props.className}
                    stickyElementsSelectors={props.config?.gridActionsBar.stickyElementsSelectors}
                >
                    {props.children}
                </StickyWrapper>
            );
        }

        return <StyledRow className={props.className}>{props.children}</StyledRow>;
    })
);
